// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"flag-1"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M4 14H11L13 16H20L18 10.5H13L11 8.5H4V14Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M13 10.5H18L20 5H13L11 3H4V8.5H11L13 10.5Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M4 3H11L13 5H20L18 10.5M4 3V14M4 3V8.5H11L13 10.5H18M4 14H11L13 16H20L18 10.5M4 14V21.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Flag1Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'flag-1',
    ref,
    icon: element,
  },
));

Flag1Icon.displayName = 'Flag1Icon';

export default Flag1Icon;
